import { BaseEvent } from '../../../../../domain/event/base-event';
export class ReferenceTableEvent extends BaseEvent {
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        metadata = {
            aggregatename: 'ReferenceTable',
            ...metadata,
        };
        super({
            subject,
            type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
//# sourceMappingURL=reference-table.event.js.map